module.exports = __webpack_public_path__ + "img/IrrigationPivot.5c64e430.png";